import { ContractDetailsMyContractsRedirect } from 'features/ContractDetails/ContractDetailsMyContractsRedirect'
import ContractDetailsContainer from 'features/ContractDetails/ContractDetailsContainer/ContractDetailsContainer'
import ContractDetailsRouter from 'features/ContractDetails/ContractDetailsRouter/ContractDetailsRouter'
import { TerminateContractPopup } from 'features/ContractDetails/ContractDetailsActions/TerminateContract'
import { ExtendContractPopup } from 'features/ContractDetails/ContractDetailsActions/ExtendContract'
import RenewFinishDatePopup from 'features/ContractDetails/ExtendContract/RenewFinishDatePopup'
import ContractDetailsTimelinesPopup from 'features/ContractDetails/ContractDetailsTimelines/ContractDetailsTimelinesPopup'
import AssignResponsiblePopup from 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsForm/AssignResponsible/Popup'
import ContractDetailsAbilityProvider from './Providers/ContractDetailsAbilityProvider'
import ContractDetailsPopupProvider from './Providers/ContractDetailsPopupProvider'
import ContractDetailsContextProvider from './Providers/ContractDetailsContextProvider'
import { DeclineContractPopup } from './ContractDetailsActions/DeclineContract'
import TerminateContractWithDate from './ContractDetailsActions/TerminateContract/TerminateContractWithDate'
import ChangeTerminationDateModal from './ContractDetailsActions/TerminateContract/ChangeTerminationDate'

const ContractDetails = () => (
  <ContractDetailsAbilityProvider>
    <ContractDetailsPopupProvider>
      <ContractDetailsMyContractsRedirect>
        <ContractDetailsContextProvider>
          <ContractDetailsContainer>
            <ContractDetailsRouter />
          </ContractDetailsContainer>
          <TerminateContractPopup />
          <TerminateContractWithDate />
          <ChangeTerminationDateModal />
          <DeclineContractPopup />
          <ExtendContractPopup />
          <RenewFinishDatePopup />
          <ContractDetailsTimelinesPopup />
          <AssignResponsiblePopup />
        </ContractDetailsContextProvider>
      </ContractDetailsMyContractsRedirect>
    </ContractDetailsPopupProvider>
  </ContractDetailsAbilityProvider>
)

export default ContractDetails
